export const SDK_VERSION = '8.7.0';
